import { HONEYPOT_FIELD_NAME } from "@homeinstead/forms/lead-form";

import "./LeadFormHoneypotField.css";

/**
 * Bait for naive bots that fill every text input. Hidden from sight and the
 * accessibility tree; humans should leave it empty.
 */
function LeadFormHoneypotField() {
  return (
    <div aria-hidden="true" className="contact-fax">
      <label>
        Fax
        <input
          autoComplete="off"
          name={HONEYPOT_FIELD_NAME}
          tabIndex={-1}
          type="text"
        />
      </label>
    </div>
  );
}

export { LeadFormHoneypotField };
